import React, { useContext } from "react";

import { PaziaDeleteModal } from "components/molecules";
import { deleteResourceActions, DeleteResourceContext } from "utils/store";
import { getApiErrorMessage, useToaster } from "utils";

interface AdminResourceDeleteModalProps {
  deleteAction: (id: number) => Promise<void>;
  onSuccessDelete: () => void;
  title: string;
  description: string;
}
export const AdminResourceDeleteModal = ({
  deleteAction,
  onSuccessDelete,
  title,
  description,
}: AdminResourceDeleteModalProps) => {
  const { showInfo, showError } = useToaster();
  const {
    state: { deleteId },
    dispatch,
  } = useContext(DeleteResourceContext);

  const onConfirm = async () => {
    if (!deleteId) return;
    try {
      await deleteAction(deleteId);
      deleteResourceActions.setDeleteResource(dispatch, 0);
      showInfo("Pomyślnie usunięto.");
      onSuccessDelete();
    } catch (e) {
      // The API says why a delete is refused (e.g. a course group that still has courses)
      showError(getApiErrorMessage(e, "Wystąpił błąd podczas usuwania."));
      console.error(e);
    }
  };

  return (
    <PaziaDeleteModal
      id="delete-modal"
      title={title}
      description={description}
      isOpen={deleteId > 0}
      onCloseRequest={() => deleteResourceActions.setDeleteResource(dispatch, 0)}
      onConfirm={onConfirm}
    />
  );
};
